import React, { useState } from 'react'
import { Drawer } from 'antd'

import { usePet } from '../../modules'

const MarkOrderSubmitted = ({ visible, order, onClose, onPerform }) => {
    const [reference, setReference] = useState('')
    const [notes, setNotes] = useState('')

    const close = () => {
        onClose()
    }

    const onComplete = (_, notif, ops) => {
        notif('Order has been marked as submitted', ops('success'))
        onPerform()
        close()
    }

    const [{ loading }, execute] = usePet('markOrderSubmittedToInsurer', {
        order: order?._id,
        reference,
        notes,
    }, { notify: true, callback: onComplete, manual: true, load: { msg: 'Submitting order...' } })

    return (
        <Drawer
            closable
            maskClosable
            visible={ visible }
            onClose={ close }
            footer={
                <div className="w-full text-right">
                    <button disabled={ loading } onClick={ execute } className="text-white hisani-btn-orange font-medium rounded-lg text-sm px-5 py-2.5 text-center">Mark Submitted</button>
                </div>
            }
            width="35%">
            <p className="font-extrabold text-3xl mb-0">Mark Order as Submitted</p>
            <div className="mb-4 mt-3 rounded-sm border border-gray-200 bg-gray-50 px-4 py-3">
                <div className="grid gap-3 md:grid-cols-2 sm:grid-cols-1">
                    <div>
                        <p className="text-xs text-gray-500 mb-1">Patient</p>
                        <p className="text-sm font-medium mb-0">{order?.patientData?.name ?? '—'}</p>
                    </div>
                    <div>
                        <p className="text-xs text-gray-500 mb-1">Insurer</p>
                        <p className="text-sm font-medium mb-0">{order?.insurerData?.name ?? '—'}</p>
                    </div>
                    <div>
                        <p className="text-xs text-gray-500 mb-1">Order No.</p>
                        <p className="text-sm font-medium mb-0">{order?.orderNo ?? '—'}</p>
                    </div>
                    <div>
                        <p className="text-xs text-gray-500 mb-1">Outstanding</p>
                        <p className="text-sm font-medium mb-0">KSh {Number(order?.outstanding ?? 0).toLocaleString()}</p>
                    </div>
                </div>
            </div>
            <div className="flex flex-wrap">
                <div className="w-full px-3 mb-1">
                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                        Reference <span className="text-gray-500 text-xs normal-case italic">(Optional)</span>
                    </label>
                    <input
                        className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                        type="text"
                        value={ reference }
                        onChange={ e => setReference(e.target.value) }
                        placeholder="Batch/claim reference" />
                </div>
                <div className="w-full px-3 mb-1">
                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                        Notes <span className="text-gray-500 text-xs normal-case italic">(Optional)</span>
                    </label>
                    <textarea
                        rows={ 4 }
                        className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                        value={ notes }
                        onChange={ e => setNotes(e.target.value) }
                        placeholder="Notes..." />
                </div>
            </div>
        </Drawer>
    )
}

export default MarkOrderSubmitted
